import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    const navState = useMemo(() => ({ from: location }), [location]);
    if (loading) {
        return (
            <div
                data-testid="auth-checking"
                style={{
                    minHeight: "100vh",
                    display: "grid",
                    placeItems: "center",
                    color: "var(--bm-text-muted)",
                    fontFamily: "var(--bm-font-display)",
                    fontStyle: "italic",
                    fontSize: "20px",
                }}
            >
                <span className="bm-pulse">⚓ steadying the helm…</span>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={navState} replace />;
    }
    return children;
}
